<template>
    <div>
            <div class="header_box">
                <div class="info_line">请至入口处扫码进入，须在{{activity_time_info.begin_time}}点前入园</div>
                <div class="info_line">预约日期：<span class="color_green0">{{activity_record_info.order_date}} - {{activity_time_info.title}}</span></div>
                <div class="info_line">预约人数：<span class="color_green0">{{activity_record_info.member_num}}人</span></div>
            </div>
            <div class="member_list">
                <template v-for="(one,index) in activity_member_list">
                    <div class="box" :key="index">
                        <div class="info_line">{{one.realname}}<div class="blank_space space2"></div>{{member_sex_arr[one.sex]}}<div class="blank_space space2"></div>{{one.phone}}</div>
                        <div class="info_line color_grey0">{{member_idtype_arr[one.idtype]}}：{{one.idcode}}</div>
                    </div>
                </template>
            </div>
            <div class="bottom_btn" v-if="activity_record_info.status == 0">
                <div class="btn" @click="routerToName('reserveRegisterMemberEdit', {activity_id, activity_record_id})">更改预约信息</div>
                <div class="btn" @click="delActivityRecord">取消预约</div>
            </div>
    </div>
</template>

<script>
    import mixins_reserve from '../../mixins/reserve'
    import * as api from "../../api/reserve";
    export default {
        name: "recordDetails"
        ,mixins: [mixins_reserve]
        ,data: function () {
            return {
                activity_record_id: {}
                ,activity_record_info: {}
                ,activity_time_info: {}
                ,activity_member_list: {}
                ,health_answer_arr: {}
                ,member_sex_arr: ['未知', '男', '女']
                ,member_idtype_arr: ['身份证','港澳通行证','台胞证','护照','军官证','士兵证']
            }
        }
        ,created: function() {
            this.activity_record_id = this.$route.params.activity_record_id;
            this.getActivityRecordDetails();
        }
        ,methods: {
            /**
             * 获取预约单详情
             */
            getActivityRecordDetails: function () {
                let that = this;

                api.getActivityRecordDetails(that.activity_record_id).then(function (res) {
                    that.activity_time_info = res.data.activity_time_info;
                    that.activity_member_list = res.data.activity_member_list;
                    that.health_answer_arr = res.data.health_answer_arr;
                    that.activity_record_info = res.data.activity_record_info;
                });
            }
            /**
             * 取消预约
             */
            ,delActivityRecord: function () {
                let that = this;

                api.delActivityRecord(that.activity_record_id).then(function () {
                    that.$toast('取消预约成功');
                    that.routerBack();
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .header_box{
        position: sticky;
        left: 0;
        top: 0;
        background-color: $color_bg_green0;
        padding: .28rem;
        box-shadow: $box_shadow_up;

        .info_line{
            font-size: .28rem;

            + .info_line{
                margin-top: .2rem;
            }
        }
    }
    .member_list{
        padding: .3rem .3rem .2rem .3rem;

        .box{
            border-radius: .12rem;
            background-color: $color_bg_grey0;
            box-shadow: $box_shadow_up;
            margin-bottom: .3rem;
            padding: .3rem;
            font-size: .28rem;

            .info_line{

                + .info_line{
                    margin-top: .2rem;
                }
            }
        }
    }
    .bottom_btn{
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: .3rem;

        .btn{
            width: 2.6rem;
            height: .8rem;
            line-height: .8rem;
            border-radius: .8rem;
            background-color: $color_bg_green1;
            text-align: center;
            font-size: .28rem;
            color: #fff;
        }
    }
</style>